<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/c9UCiL/tc-custom/9781459213968.jpg?1725276352472" alt="This image is the cover for the book If I Die, Soul Screamers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">If I Die, Soul Screamers
      </h1>
      <p class="bookDescription body article font2">
        <b><i>New York Times</i>–Bestselling Author: A teenage banshee may be the only hope against a hot new math teacher with a very dark side . . . </b><br/><br/>The entire school’s talking about the gorgeous new math teacher, Mr. Beck. Everyone except Kaylee Cavanaugh. After all, Kaylee’s no ordinary high-school junior. She’s a banshee—she screams when someone dies.<br/><br/>But the next scream might be for Kaylee . . . <br/><br/>Yeah—it’s a shock to her, too. So to distract herself, Kaylee’s going to save every girl in school. Because that hot new teacher is really an incubus who feeds on the desire of unsuspecting students. The only girls immune to his lure are Kaylee and Sabine, her boyfriend’s needy ex-girlfriend. Now the unlikely allies have to get rid of Mr. Beck, before he discovers they aren’t quite human, either.<br/><br/>But Kaylee’s borrowed lifeline is nearing its end. And those who care about her will do anything to save her life. Anything . . . <br/><br/>“Fast-paced . . . with dollops of humor.” —<i>Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rachel Vincent
      </h2>
      
      <p class="authorDescription body article">New York Times bestselling author Rachel Vincent loves good chocolate, comfortable jeans, and serial commas. She&rsquo;s older than she looks and younger than she feels, but is convinced that for every day she spends writing, one more day will be added to her lifespan. Now absorbed in the dark, tangled loyalties of her UNBOUND world, as well as the travails of a teenage banshee in her SOUL SCREAMERS world, Rachel can be found online at www.rachelvincent.com or urbanfantasy.blogspot.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?005ebf2d